<template>
  <div>
    <el-form :model="formData" size="small" :inline="true" label-width="80px" ref="ruleForm" :rules="rules">
      <el-form-item label="时间：" prop="nodeTime">
        <el-date-picker
          v-model="formData.nodeTime"
          type="month"
          value-format="yyyy-MM"
          placeholder="选择月份">
        </el-date-picker>
      </el-form-item>
      <br/>
      <el-form-item label="名称：" prop="nodeName">
        <el-input v-model.trim="formData.nodeName" placeholder=""></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      formData: {},
      rules: {
        nodeTime: [
          { required: true, message: '不能为空', trigger: 'change' }
        ],
        nodeName: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
      }
    }
  },
  mounted() {
    let formData = JSON.parse(JSON.stringify(this.data));
    formData['year'] && (formData['nodeTime'] = formData['year'] + '-' + formData['month']);
    this.formData = formData;
  }
}
</script>

<style lang="stylus" scoped>

</style>